module.exports = "/_next/static/images/2f2e7dbd9d41dd365d309989e9ba06ea-coins-icon.svg.webp";